<template>
  <div class="fourthPage">
    <div class="pageBody">
      <el-row :gutter="20" justify="center" align="middle" class="row">
        <el-col :span="8" class="col">
          <img src="/static/imgs/fourthPage/1.png">
        </el-col>
        <el-col :span="16" class="col">
          <img src="/static/imgs/fourthPage/2.png">
        </el-col>
      </el-row>
      <el-row :gutter="20" justify="center" align="middle" class="row">
        <el-col :span="8" class="col">
          <img src="/static/imgs/fourthPage/3.png">
        </el-col>
       
        <el-col :span="16" class="col">
          <img src="/static/imgs/fourthPage/4.png">
        </el-col>
      </el-row>
    </div>
  </div>

</template>

<script>
export default {
  name: "fourthPage",
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.fourthPage {
  margin: 0 0 0 0;
  background-color: whitesmoke;
  padding: 140px 0 0 0;
}
.pageBody {
  .row {
      padding-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    .col {
      height: 100%;
      img {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fourthPage.vue